const createNewRequest = function() {
  const form = document.querySelector("form")
  const id = parseInt(form.getAttribute("action").split("/").pop()) || "newRequest"

  return {
    id: id,
    title: `${document.querySelector("#request_user_id option:checked").innerText} (editing)`,
    start: Date.parse(document.querySelector("#request_start_at").value),
    end: Date.parse(document.querySelector("#request_end_at").value),
    allDay: document.querySelector("#request_all_day").checked,
    className: `vehicle-${document.querySelector("#request_vehicle_id").value}`
  }
}

const updateNewRequest = function(calendar) {
  if (!calendar) return

  var request = createNewRequest()
  calendar.gotoDate(request.start)

  var existingRequest = calendar.getEventById(request.id)
  existingRequest && existingRequest.remove()
  calendar.addEvent(request)
}

export { createNewRequest, updateNewRequest }
